<template>
  <div
    class="flex min-h-15 items-center gap-4 bg-slate-900 px-8 py-4"
  >
    <p class="text-slate-100">
      <slot />
    </p>
    <slot name="controls" />
  </div>
</template>
